var map = {
	"./4k-wallpaper-android-wallpaper-astro-astrology-1146134.jpg": "80ae",
	"./astronomy-atmosphere-earth-exploration-220201.jpg": "fe31",
	"./galaxyspace.jpg": "9abf",
	"./milky-way-illustration-1169754.jpg": "5555",
	"./photo-of-deep-sky-object-816608.jpg": "9d7c",
	"./photo-of-night-sky-1025469.jpg": "9506",
	"./sky-space-dark-galaxy-2150.jpg": "721a",
	"./sky-space-milky-way-stars-110854.jpg": "a8cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cb5f";